import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { graphql } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import Helmet from 'react-helmet';

import Spinner from '../../../../components/global/Spinner';
import { AlbumForWebGalleries } from '../../graphql/queries/album';
import { getAsset } from '../../../../util/assets';
import Button from '../../../../components/global/Button';
import { isAlbumFolder } from '../../../../util/album-folder';
import ErrorView from '../../../../components/global/ErrorView';

const propTypes = {
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
  }),
  loading: PropTypes.bool,
};

const WebGalleryFaces = ({ entity, loading }) => {
  if (loading) {
    return (
      <div className="d-flex mt-4">
        <Spinner className="m-auto" />
      </div>
    );
  }

  const isAlbumFolderBool = isAlbumFolder(entity);

  const albumFolderId = isAlbumFolderBool
    ? entity?.id
    : entity?.root_album_folder?.id;

  const joinsEnabled = isAlbumFolderBool
    ? entity.joins_enabled
    : entity.root_album_folder?.joins_enabled;

  if (!joinsEnabled) {
    return (
      <ErrorView
        location={{
          state: {
            error: `Sorry, joins have been disabled on this ${
              isAlbumFolderBool ? 'gallery' : 'album'
            }`,
          },
        }}
      />
    );
  }

  return (
    <Fragment>
      <Helmet>
        <title>Faces &ndash; Waldo</title>
      </Helmet>

      <div className="px-sm-2 px-md-5 px-0">
        <div className="d-flex flex-column align-items-center mt-3">
          <img
            src={getAsset('/waldo-icon.svg')}
            className="grayscale-faded mb-3"
            width="40"
            alt="Waldo Icon"
          />
          <h3 className="text-extra-bold text-center mb-1">
            Looking for someone specific?
          </h3>
          <p className="text-light text-bold text-center">
            Join a face to this album! I&apos;ll alert you when I find matched
            photos.
          </p>
          {albumFolderId && (
            <Button
              to={`/discover/album-folder/${albumFolderId}/start?fromGallery=true`}
            >
              Join a Face
            </Button>
          )}
        </div>
      </div>
    </Fragment>
  );
};

WebGalleryFaces.propTypes = propTypes;

const withAlbum = graphql(AlbumForWebGalleries, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
    },
  }),
  props: ({ data: { loading, album } }) => ({
    loading,
    entity: album,
  }),
});
export { WebGalleryFaces as WebGalleryFacesComponent };

export default compose(withRouter, withAlbum)(WebGalleryFaces);
